import React from "react";
import { TABLES } from "../../Utils/tableConst"
import { Table } from "../Table"

export const TableQuery2 = () => (
  <>
    <Table tableData={TABLES.QUERY_2} theme="default" />
    <Table tableData={TABLES.QUERY_2_SECOND} theme="default" />
  </>
);